export default {
  "meeting": {
    applyrecurring: 'As alterações serão aplicadas à nova programação recorrente. As reuniões anteriores permanecerão inalteradas.',
    recurrenceDescribeTwo: 'Ocorre a cada {loopPulse} semanas às {week}, de {start} até {end}',
    wanttodeletethemeetingfollowTwo: 'Excluir a reunião selecionada e todas as reuniões recorrentes seguintes?',

    loopCycleSelectTips: 'Selecione o dia da semana para repetir.',

    export: 'Exportar',
    exportMeetingFileFuncTipsTitle: 'Confirmação de exportação',
    exportMeetingFileFuncTipsContentOne: 'Nenhum filtro foi aplicado. O sistema exportará os registros de reuniões do ano atual por padrão.',
    exportMeetingFileFuncTipsContentTwo: 'Para exportar reuniões de outro período, aplique os filtros desejados antes de exportar.',

    myMeetingSearch: 'Minhas reuniões',
    meetingTimeSearch: 'Horário da reunião',
    meetingRoomsSearch: 'Sala de reunião',

    Recurring: 'Recorrente:',
    wanttodeletethemeetingfollow: 'Tem certeza de que deseja excluir esta reunião e todas as reuniões seguintes?',
    endTimeCannotBeforeBeginTime: 'A data de término não pode ser anterior à data de início',
    Thismeeting: 'Esta reunião',
    Recurringmeeting: 'Reunião recorrente',
    Checkin: 'Check-in:',
    checkinTip: 'Após a ativação, os participantes podem fazer check-in escaneando o código QR do agendador de salas.',
    Recurrence_Setrecurrence: 'Definir recorrência',
    Recurrence_Start: 'Início',
    Recurrence_RepeatEvery: 'Repetir a cada',
    Recurrence_Week: 'Semana',
    Recurrence_end: 'Fim',
    recurrenceDescribe: 'Ocorre a cada {week} começando em {start} até {end}',
    Recurrence_DoesnotRepeat: 'Não repetir',
    Recurrence_Weekly: 'Semanal',

    AddressBookUser: 'Usuário',
    AddressBookPhonebook: 'Agenda de contatos',

    RoomByPeopleNum1: '2 pessoas ou menos',
    RoomByPeopleNum2: '3-6 pessoas',
    RoomByPeopleNum3: '7-10 pessoas',
    RoomByPeopleNum4: '11-15 pessoas',
    RoomByPeopleNum5: '16-20 pessoas',
    RoomByPeopleNum6: '21-30 pessoas',
    RoomByPeopleNum7: 'Mais de 30 pessoas',

    whoAreBound: 'Usuários vinculados a uma conta do sistema verão a reunião no calendário do sistema. Usuários que fornecerem um e-mail receberão notificações por e-mail. Para receber notificações, complete suas informações em [Meu Perfil].',

    AttendessMeeting: 'Participantes:',
    SelectAttendessMeetingTip: 'Selecionar participantes',

    MeetingFilter: 'Filtro de reuniões',
    HostedbyMe: 'Organizado por mim',
    Invitedby: 'Convidado por mim',
    Otherby: 'Outros',

    "AddressIsDuplicated": "O e-mail do contato está duplicado",
    "meetingExpired": "Expirado",
    titlePhoneFormat: 'O telefone só pode conter números, () + e -.',
    "selectField": "Selecione um arquivo",
    "Limit255": "O nome do arquivo não pode exceder 255 caracteres",
    "nameLimit25": "O nome não pode exceder 25 caracteres",
    "emailLimit50": "O email não pode exceder 50 caracteres",
    "emailFormatError": "Digite um endereço de email válido",
    "phoneLimit11": "O número de telefone pode ter até 11 dígitos",
    "ParticipantsEmail": "Email do participante:",
    "listIsEmpty": "A lista está vazia",
    "Startimporting": "Iniciar upload",
    "Selectfile": "Selecionar arquivo",
    "Importfile": "Importar arquivo",
    "ImportfileTip": "*Apenas arquivos CSV no formato Outlook (.csv) ou vCard (.vcf) são suportados para importação.",
    "addParticipants": "Adicionar participante",
    "multiselectdeselect": "Dica de exclusão de etiqueta",
    "multiselectselected": "Dica de seleção",
    "enterOrSelectALabel": "Selecione o email do participante",
    "deleTitleContact": "Tem certeza de que deseja excluir este contato?",
    "delTitleContactContent": "Excluir contato?",
    "deleteContactTitle": "Selecione o contato que deseja excluir",
    "editcontact": "Editar contato",
    "Name": "Nome",
    "email": "Email",
    "telephoneNumber": "Telefone",
    "Addcontact": "Adicionar contato",
    "Importcontactfile": "Importar contatos",
    "AddressBook": "Lista de contatos",
    "Participants": "Participantes:",

    bindTipContent:"Esta organização já vinculou um calendário de terceiros. Agende reuniões pelo Outlook/Teams.",
    Productupdatenews: 'Uma nova atualização de versão foi lançada. ',
    bookingPerson: 'Reservado por',
    "DeleteMeeting": "Excluir reunião",
    "wanttodeletethemeeting": "Deseja excluir a reunião?",
    "hasbeendeleted": "A reunião foi excluída",
    "theMeetingWasAborted": "Encerrar reunião mais cedo",
    "theMeetingWasAbortedContent": "Deseja encerrar a reunião mais cedo?",
    "determineTheAbortTask": "Encerrar reunião mais cedo",
    "theMeetingEndedEarly": "A reunião foi encerrada mais cedo.",
    "with": "com",
    "Other": "Outro",
    "tasks": "conflito de tarefas",
    "conflict": "O seguinte horário de reunião entra em conflito:",
    "meetConflicts": "Horários passados não podem ser selecionados",
    "itIsNotAllowedToSelectThePastTime": "Selecionado",
    "selected": "Selecione no máximo 5 salas de reunião",
    "noOverFive": "Opiniões de aprovação",
    "approvalOpinions": "Além do limite de tempo, não pode ser selecionado",
    "beyondTheTimeLimitItCannotBeSelected": "Mês de início",
    "startMonth": "até",
    "to": "Mês de término",
    "stopMonth": "Sem início",
    "didnTStart": "Em andamento",
    "ONGOING": "Terminado",
    "ENDED": "já foi",
    "hasBeen": "reserva",
    "booking": "Aprovação",
    "Approval": "Sala de reunião",
    "MeetingRoom": "Todas as salas",
    "AllRoom": "Disponível",
    "Available": "Iniciar reunião",
    "Initiate": "Aprovação da reunião",
    "MeetingApproval": "Mês anterior",
    "PreviousMonth": "Hoje",
    "Today": "Próximo mês",
    "NextMonth": "Ano/Mês",
    "YearMonth": "Exibição de tempo",
    "TimeDisplay": "Abreviação do título da reunião",
    "MeetingTitleAbbreviation": "Iniciar reunião",
    "InitiateMeeting": "Próximas reuniões",
    "PendingMeetings": "Todas as reuniões",
    "AllMeetings": "Não há reuniões para participar no momento",
    "noMeetings": "Não iniciado",
    "NotStarted": "Organizador",
    "Organizer": "Data e hora",
    "MeetingDateTime": "Localização",
    "MeetingLocation": "Assunto da reunião",
    "MeetingSubject": "Pessoas convidadas",
    "Invited": "Pessoas aceitas",
    "PeopleAccepted": "Editar reunião",
    "EditMeeting": "Cancelar reunião",
    "CancelMeeting": "Iniciar/Editar reunião",
    "InitiateEditMeeting": "Assunto",
    "Subject": "Assunto",
    "Presenter": "Apresentador :",
    "DateTime": "Data e Hora",
    "TimeAndZone": "Fuso horário",
    "Attendees": "Participantes",
    "Addrequiredattendees": "Adicionar participantes obrigatórios",
    "SelectRooms": "Selecionar salas",
    "Reminder": "Lembrete",
    "Remindbeforestart": "Lembrar antes de iniciar",
    "Confirm": "Confirmar",
    "topic": "Assunto :",
    "topicplace": "Novo título da reunião :",
    "speaker": "Apresentador :",
    "speakerplace": "Por favor, insira as informações do apresentador",
    "DateAndTime": "Data & Hora :",
    "TimeZone": "Fuso horário",
    "EndDate": "Data de término",
    "Rooms": "Salas :",
    "Notes": "Notas :",
    "MeetingRoomApproval": "Aprovação da sala de reunião",
    "PendingApproval": "Aguardando aprovação",
    "Approved": "Aprovado",
    "nopendingapprovals": "Não há aprovações pendentes",
    "Applicant": "Solicitante",
    "UsageTime": "Tempo de uso",
    "ApprovalResult": "Resultado da aprovação",
    "ApprovalComments": "Comentários sobre a aprovação",
    "Approve": "Aprovar",
    "Reject": "Rejeitar",
    "Search": "Pesquisar",
    "Filter": "Filtrar",
    "scanTheQRCodeToSignIn": "Escanear o código QR para registrar"
  },
  "NPS": {
    "Relay": "Relé",
    "RelaySettings": "Configurações de Relé",
    "DevicePower": "Controle de energia do dispositivo",
    "DeviceElevation": "Controle de elevação",
    "LinageWithNPSPower": "Vinculação com energia NPS",
    "PresentationSwitch": "Interruptor de apresentação",
    "Duplicate": "Duplicar",
    "LinkagewithNPSPowe": "Vinculação com energia NPS",
    "npsTooltip": "Dispositivos USB só podem ser chamados pelo PC host que esteja conectado a HDMI OUT 1.",
    "nmpTooltip": "Clique no botão 'Duplicar' para espelhar o conteúdo da tela em outras telas, sincronizando a exibição em várias telas."
  },
  "textTemplate": {
    "template2513": "Transmissão de emergência de incêndio",
    "template2514": "Por favor, evacue pela saída de emergência e pela saída de incêndio para um local seguro, de acordo com o plano de fuga de incêndio.",
    "moreTemplate": "Limite de modelo atingido",
    "add": "Adicionar",
    "SetTemplate": "Definir modelo",
    "Emergency": "Emergência",
    "General": "Geral",
    "BroadcastDevices": "Dispositivo de transmissão:",
    "selectBroadcastDevices": "Por favor, selecione os dispositivos de transmissão",
    "All": "Todos",
    "AddTemplate": "Adicionar modelo",
    "EditTemplate": "Editar modelo",
    "deleteTemplage": "Tem certeza de que deseja excluir o modelo selecionado?",
    "title": "Excluir modelo",
    "selectTemplage": "Por favor, selecione um modelo!",
    "DeleteCancelled": "Exclusão cancelada!",
    "DeletedSuccessfully": "Excluído com sucesso!",
    "noData": "Nenhum modelo disponível, clique no canto superior direito para adicionar um modelo.",
    "TemplateTitle": "Título do modelo:",
    "BroadcastType": "Tipo de transmissão:",
    "BroadcastTypeDialog": "Tipo de transmissão:",
    "selectBroadcastType": "Por favor, selecione o tipo de transmissão",
    "BroadcastDuration": "Duração da transmissão:",
    "BroadcastDevice": "Dispositivo de transmissão:",
    "BroadcastContent": "Conteúdo da transmissão:"
  },
  "common": {
    "mediaTimeStateNotifyErrorTitle": "Erro!",
    "mediaTimeStateNotifyErrorContent": "Seu serviço de transmissão expirou, por favor entre em contato com seu agente para renová-lo a tempo.",
    "mediaTimeStateNotifyWarnTitle": "Atenção!",
    "mediaTimeStateNotifyWarnContent": "Você está atualmente no estado de teste e pode transmitir e fazer streaming para no máximo 3 dispositivos terminais.",
    "mediaTimeStateNotifySuccessTitle": "Renovação bem-sucedida",
    "mediaTimeStateNotifySuccessContent": "Seu serviço de transmissão está pronto para uso normal. Obrigado.",
    "company": "Nome da empresa:",
    "tableAddress": "Endereço:",
    "createTime": "Data de criação:",
    "email": "Email:",
    "phone": "Telefone:",
    "Trial": "Teste",
    "TrialWorkstation": "Atualmente você está no estado de teste e pode transmitir e fazer streaming para no máximo 3 dispositivos terminais.",
    "Normal": "Normal",
    "NormalWorkstation": "O período de validade do seu serviço de transmissão vai de",
    "to": "a",
    "Advent": "Próximo",
    "AdventWorkstationOne": "Seu serviço de transmissão expirará em",
    "AdventWorkstationTwo": ", por favor entre em contato com seu agente para renová-lo a tempo para o uso normal.",
    "Expired": "Expirado",
    "ExpiredWorkstation": "Seu serviço de transmissão expirou, por favor entre em contato com seu agente para renová-lo a tempo."
  },
  "route": {
    "dashboard": "Painel",
    "i18n": "I18n",
    "Devices": "Dispositivos",
    "Broadcast": "Transmissão",
    "Schedule": "Agenda",
    "Resources": "Recursos",
    "Live": "Ao vivo",
    "meetings": "Reunião"
  },
  "navbar": {
    "updates":"Últimas atualizações",
    "logOut": "Sair",
    "screenfull": "tela cheia",
    "oprofile": "Meu perfil",
    "settings": "Configurações",
    "language": "Idioma",
    "BackTianwa": "Voltar ao Tianwa",
    "newUserGuide": "Guia do novo usuário"
  },
  "feedback": {
    "Feedback": "Comentários",
    "email": "Por favor, deixe seu e-mail para nosso feedback.",
    "content": "Bem-vindo e deixe mensagens para melhorar nossos produtos. Obrigado pelos seus comentários.",
    "submit": "Enviar",
    "emailNoEmpty": "O e-mail não pode estar vazio",
    "emailTrueRule": "Por favor, insira o formato de e-mail correto",
    "contentNoEmpty": "O conteúdo não pode estar em branco",
    "feedbackSuccess": "Feedback bem-sucedido",
    "feedbackFailed": "Falha no feedback",
    "emailNoChinese": "A caixa de correio não pode conter caracteres chineses",
    "emailLength": "Entre 5 e 50 caracteres de comprimento",
    "emailSpecialString": "A caixa de correio não pode conter strings especiais"
  },
  "login": {
    checkPasswordTitleTwo: 'Defina uma senha com pelo menos 6 caracteres, incluindo letras e números. Caracteres especiais são permitidos (sem restrições).',
    captcha: 'Código de verificação',
    checkPasswordTitle: 'A senha deve ter pelo menos 6 caracteres e não pode ser apenas números',
    "title": "BEM-VINDO",
    "logIn": "Entrar",
    "consoleLogin": "Login do console",
    "username": "Nome de usuário",
    "password": "Senha",
    "any": "qualquer",
    "thirdparty": "Ou conecte-se com",
    "thirdpartyTips": "Não pode ser simulado localmente, então combine com sua própria simulação de negócios!",
    "placeholder": ["Nome de usuário","Senha","Código de verificação"],
    "userNameTitle": "Nome de usuário errado!",
    "forget": "Esqueceu?",
    "loginTitle0": "Login bem-sucedido!",
    "loginTitle1000": "Nome de usuário ou senha errados!",
    "loginTitle1001": "Nome de usuário e senha devem ser preenchidos!",
    "loginTitle1002": "O código de verificação deve ser preenchido!",
    "loginTitle1003": "O status do usuário é ilegal, falha no login!",
    "loginTitle1004": "Erro no código de verificação!",
    "loginTitle1005": "Não logado, faça login primeiro!",
    "loginTitle1006": "As duas senhas são diferentes!",
    "loginTitleUserName": "Nome de usuário deve ser preenchido!",
    "loginTitlePwd": "Senha deve ser preenchida!",
    "loginTitleVercode": "Código de verificação deve ser preenchido!",
    "titleLoginNameFormat": "A conta deve ser composta por caracteres, ou caracteres e números.",
    "privacy": "Q-NEX User Privacy Policy",
    "privacyContent": "Agree to",
    "_zh": "中文(简体)",
    "_en": "_English",
    "_ko": "한국어",
    "_zh_ft": "中文(繁體)"
  },
  "home": {
    "btnDevices": "Dispositivos",
    "btnRoadcast": "Transmissão",
    "btnResources": "Recursos",
    "btnLive": "Ao vivo",
    "meetings": "Reunião",
    "todaySchedule": "Agenda de hoje",
    "allSkedules": "Todas as agendas",
    "details": "Detalhes",
    "btnStart": "Iniciar",
    "titleContent": "Saudações! O Console Q-NEX está ao seu serviço. Vamos começar!",
    "btnExit": "Sair"
  },
  "devices": {
    ptzCamera:'Câmera PTZ',
    "start": "INICIAR",
    "stop": "PARAR",
    "nmpPowerOff_mandatory": "Em transmissão (não obrigatória)",
    "nmpPowerOff_nomandatory": "Em transmissão (não obrigatória). Continuar execução?",
    "nmpsPowerOff_mandatory": "Alguns NMPs estão em transmissão (obrigatório).",
    "nmpsPowerOff_nomandatory": "Alguns NMPs estão em transmissão (não obrigatória). Continuar execução?",
    "reset": "Redefinir",
    "displayedInTheControlArea": "Exibido no centro de controle",
    "dragOrder": "Arrastar ordem",
    "areaSettingTwoNotice": "*O controle RS232, AC e controle remoto são exibidos no centro de controle dependendo do status de vinculação do NMP no painel de controle.",
    "areaSettingThreeNotice": "*O controle CBX é exibido no centro de controle dependendo do status de vinculação do NMP no painel de controle.",
    "controlSet": "Configurações do centro de controle",
    "vcbNoLine": "Nenhum dispositivo CBX está online",
    "vcbNoBound": "Nenhum dispositivo CBX está vinculado",
    "tscNoBound": "RS232 no TSC não está vinculado a nenhum dado. Informe ao administrador para vincular no painel de controle.",
    "light": "Controle de energia",
    "vcbpower": "Energia",
    "rs232Control": "Controle Serial",

    "CBX": {
    "powerSupplyON": "Ligar",
    "powerSupplyOFF": "Desligar",
    "lockScreenON": "Bloquear",
    "lockScreenOFF": "Desbloquear",
    "childLockON": "Bloqueio infantil ativado",
    "childLockOFF": "Bloqueio infantil desativado",
    "energySavingON": "Economia de energia ativada",
    "energySavingOFF": "Economia de energia desativada",
    "signalSourceSwitchingON": "OPS",
    "signalSourceSwitchingOFF": "Android",
    "volumeAdjustment": "Alto-falante",
    "brightAdjustment": "Brilho",
    "other": "Outras funcionalidades..."
  },

    "InterfaceOne": "Interface Um",
    "InterfaceTwo": "Interface Dois",
    "abcStyleP": "Desculpe! TSC e (NMP, MBX, NPS, NDP100, NDP500) não podem ser selecionados ao mesmo tempo",
    "masterControl": "principal",
    "powerSupply": "Poder",
    "RecordingControl": "Controle de gravação",
    "RecordingControlSystem": "Sistema de captura de conferência",
    "LiquidCrystal": "Tela LCD interativa",
    "projector": "Projetor",
    "othertype": "Outro",
    "lockScreen": "Bloqueio",
    "childLock": "Bloqueio infantil",
    "energySaving": "Economia de energia",
    "signalSourceSwitching": "Fonte de entrada",
    "volumeAdjustment": "Alto-falante",
    "brightAdjustment": "Brilho",
    "other": "Outras características",
    "otherFunction": "Função",
    "send": "Enviar",
    "ON": "ON",
    "OFF": "OFF",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_MAGNETICLOCK": "MAGNETICLOCK",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    "_AIR": "Ar condicionado",
    "titleDevices": "Filtro de grupos:",
    "content": "Pesquisar",
    "selectALL": "Selecionar TUDO",
    "SelectRecentPage": "Selecionar a página atual",
    "controlPanel": "Centro de controle",
    "displayInputSwitch": "Interruptor de entrada de exibição",
    "chooseINPUTSources": "Escolher fontes de ENTRADA",
    "speakerVolume": "Volume de áudio",
    "bass": "Graves",
    "treble": "Agudos",
    "MICVolume": "Volume MIC",
    "AirConditioning": "Ar condicionado",
    "model": "Modelo",
    "setTemp": "Temperatura definida",
    "fanSpeed": "Velocidade do ventilador",
    "bold": "Oscilação",
    "projectionScreen": "Tela de projeção",
    "electronicLock": "Fechadura elétrica",
    "electronicLock1": "Fechadura elétrica",
    "selectDevices": "Por favor, selecione um dispositivo ou um grupo de dispositivos",
    "isCompelType": "O controle do dispositivo está indisponível devido à transmissão obrigatória, tente novamente mais tarde.",
    "mainPower": "Fonte principal",
    "extraPower": "Fonte extra",
    "power": "Potência",
    "hdmiBroadcast": "Transmissão",
    "equipmentState1": "Ligar",
    "equipmentState2": "Desligar",
    "equipmentState3": "Offline",
    "main": "Principal",
    "external": "Externo",
    "ProjectionScreen": "Tela de projeção",
    "UP": "SUBIR",
    "DOWN": "DESCER",
    "LOCK": "BLOQUEAR",
    "UNLOCK": "DESBLOQUEAR",
    "PleaseDevice": "Por favor, selecione o(s) dispositivo(s) à esquerda",
    "RemoteControl": "Controle remoto",
    "Action": "Ação",
    "Devicefilter": "Filtro de dispositivo",
    "DeviceStatus": "Status",
    "DeviceType": "Tipo",
    "currentAudioSource": "Fonte de áudio atual",
    "audioSwitching": "Interruptor de saída de áudio"
  },
  "broadcast": {
    "isBoarding": "(Em transmissão)",
    "last3Days": "ÚLTIMOS 3 DIAS",
    "last7Days": "ÚLTIMOS 7 DIAS",
    "last30Days": "ÚLTIMOS 30 DIAS",
    "historyRecord": "Histórico",
    "SelectDestination": "1.Selecionar destino",
    "BroadcastingConsole": "2.Console de transmissão",
    "Notification": "Notificação",
    "btnStop": "Parar",
    "btnStart": "Iniciar",
    "Letters60": "(menos de 60 caracteres)",
    "Letters300": "(menos de 300 caracteres)",
    "LastingTime": "Duração:",
    "Title": "Título:",
    "Content": "Conteúdo:",
    "Cannotquit": "Transmissão obrigatória",
    "ChooseMedia": "Selecionar um arquivo de mídia",
    "Broadcasting": "Transmissão",
    "dialogTitle": "Recursos de vídeo e áudio",
    "SortBy": "Ordenar por",
    "btnBake": "Voltar para a página anterior",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "save": "Salvar",
    "coxAll": "Tudo",
    "PublicCloud": "Armazenamento público",
    "IndividualCloud": "Armazenamento pessoal",
    "selFile": "Selecione um arquivo ou um grupo.",
    "StopBroadcast": "Parar transmissão",
    "StartBroadcasting": "Iniciar transmissão",
    "StopBroadcasting": "Parar transmissão",
    "ForceQuit": "Forçar saída",
    "PleaseMediaFile": "Selecione um arquivo de mídia",
    "PleaseDevice": "Selecione um dispositivo",
    "broadcast_0": "Iniciar transmissão",
    "broadcast_2500": "Excede o número máximo de dispositivos conectáveis ao servidor de mídia",
    "broadcast_2501": "Erro no arquivo de transmissão",
    "broadcast_2502": "Transmissão encerrada",
    "broadcast_2503": "Não foi possível obter informações do servidor de mídia",
    "broadcast_2510": "Atenção! Você está atualmente no estado de avaliação, até 3 dispositivos terminais podem receber comandos de transmissão. Verifique a quantidade de dispositivos que você selecionou.",
    "broadcast_2018": "O serviço de transmissão está desligado.",
    "broadcast_2019": "O serviço de transmissão expirou.",
    "broadcast_2512": "Excedeu o limite de quantidade de modelos.",
    "broadcast_2513": "Transmissão de emergência em caso de incêndio.",
    "broadcast_2514": "Por favor, evacue para um local seguro pela saída de emergência e saída de incêndio de acordo com o plano de fuga.",
    "broadcast_2006": "Dispositivo não encontrado.",
    "broadcast_2": "O serviço de disco está anormal.",
    "broadcast_2515": "Selecione um dispositivo que não tenha capacidades de transmissão.",
    "broadcast_2516": "Selecione arquivos que excedem a resolução máxima suportada pelo NMP.",
    "broadcast_2517": "Selecione arquivos que excedem a resolução máxima suportada pelo NDP500.",
    "broadcast_Title": "Alerta de transmissão.",
    "broadcast_TitleNDP500": "Alerta de transmissão NDP500.",
    "broadcast_content": "O dispositivo suporta até 4K@30FPS, com resolução ótima de 1080P@30FPS.",
    "broadcast_contentNDP500": "NDP500/600 suporta até 1080P@30FPS, com resolução ótima de 720P@30FPS.",
    "broadcast_noSupported": "Os seguintes vídeos selecionados não são compatíveis para transmissão:",
    "broadcast_noSupportedNDP500": "Os seguintes vídeos selecionados não são compatíveis para transmissão no NDP500/600:"
  },
  "resources": {
    "uploadNameLengthError": "O nome do arquivo enviado não pode exceder 100 palavras!",
    "onUploadFile": "Sem arquivos para enviar",
    "open": "Abrir",
    "fold": "Dobrar",
    "close": "Fechar",
    "PublicCloud": "Armazenamento público",
    "IndividualCloud": "Armazenamento pessoal",
    "TransfersHistory": "Histórico de transferências",
    "btnDownload": "Baixar",
    "btnDelete": "Excluir",
    "btnUploadFile": "Enviar arquivo",
    "btnNewFolder": "Nova pasta",
    "btnBake": "Voltar para o anterior",
    "coxAll": "Tudo",
    "uploadError": "O tamanho do arquivo enviado não pode exceder 1 GB!",
    "MD5": "Verificar MD5",
    "merge": "Mesclando",
    "transcoding": "Transcodificando",
    "uploadFailed": "Falha ao enviar",
    "fileError": "Erro de leitura do arquivo, por favor, verifique o arquivo.",
    "tableName": "Nome",
    "tableSize": "Tamanho",
    "tableType": "Tipo",
    "tableTimeAdded": "Hora adicionada",
    "tableAction": "Ação",
    "btnRename": "Renomear",
    "btnMoveTo": "Mover para...",
    "ClearAll": "Limpar tudo",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "save": "Salvar",
    "addSuccess": "Adicionado com sucesso!",
    "addError": "Falha ao adicionar!",
    "editSuccess": "Editado com sucesso!",
    "editError": "Falha ao editar!",
    "delSuccess": "Exclusão bem-sucedida!",
    "delError": "Falha ao excluir!",
    "diskError3000": "Excedeu o tamanho total do espaço, operação falhou!",
    "diskError3001": "Excedeu a quantidade do espaço público utilizado, operação falhou!",
    "diskError3002": "Excedeu a quantidade do espaço pessoal utilizado, operação falhou!",
    "diskError3003": "Não é possível encontrar os dados, verifique se o servidor de mídia está vinculado!",
    "diskError3004": "O nome da pasta já existe!",
    "diskError3005": "Falha ao obter a pasta!",
    "diskError3006": "No mesmo nível, não pode criar mais de 99 pastas!",
    "diskError3007": "O mesmo nome de arquivo existe e a modificação falhou!",
    "diskError3008": "O mesmo nome de pasta existe e a modificação falhou!",
    "diskError3009": "O arquivo excede o espaço restante e o upload falhou!",
    "diskError3010": "Falha no upload!",
    "diskError3011": "Falha na verificação do arquivo, por favor, envie novamente o arquivo!",
    "diskError3012": "Falha ao obter o endereço do serviço de nuvem privado, operação falhou!",
    "diskError3013": "Combinações de arquivos múltiplos não podem exceder 100 MB, arquivos grandes devem ser baixados separadamente!",
    "diskError3014": "Falha na compactação, por favor, selecione o arquivo novamente para download!",
    "diskError3015": "Você precisa de permissão para realizar esta ação",
    "downloadError": "Falha ao baixar!",
    "mobileError": "Falha ao mover!",
    "root": "Todos os arquivos",
    "Name": "Nome",
    "Size": "Tamanho",
    "Type": "Tipo",
    "uploadFile": "Fazer upload de arquivo",
    "newFolder": "Nova pasta",
    "tableTime": "Tempo",
    "permission": "Permissões insuficientes!",
    "notifyTitle": "Notificação",
    "notifyContent": "O usuário não tem permissões suficientes para acessar!",
    "sortFileName": "Nome do arquivo",
    "sortTime": "Tempo",
    "sortSize": "Tamanho",
    "sortType": "Tipo",
    "moveTo": "Mover para",
    "test": "Novo",
    "delTitle": "Excluir?",
    "delTitleContent": "O conteúdo selecionado será excluído do banco de dados. A operação não pode ser desfeita. Você tem certeza de que deseja continuar?",
    "delCancelButton": "Cancelar",
    "delConfirmButton": "Confirmar"
  },
  "userMge": {
    "userName": "Nome de usuário:",
    "jobNumber": "ID do Funcionário:",
    "email": "E-mail:",
    "phone": "Telefone:",
    "group": "Grupo:",
    "oldPassword": "Senha Antiga:",
    "newPassword": "Nova Senha:",
    "confirmNewPassword": "Confirmar Nova Senha:",
    "btnSave": "Salvar Alterações",
    "titleChangePassword": "Alterar Senha",
    "titleMyProfile": "Meu Perfil",
    "name": "Apelido:",
    "error1400": "A conta (personalizada) já existe, a operação falhou!",
    "error1401": "A conta (gerada pelo sistema) já existe, a operação falhou!",
    "error1402": "O grupo não existe, a importação falhou!",
    "error1403": "Erro de dados",
    "error1404": "Permissões insuficientes",
    "selUser": "Selecione um usuário!",
    "error1405": "Falha ao obter a função",
    "error1406": "O formato dos dados de informações do usuário importado está incorreto",
    "error1407": "O e-mail já existe e a operação falhou.",
    "error1408": "O telefone já existe e a operação falhou.",
    "editSuccess": "Salvo com sucesso!",
    "ChangePassword": "Alterar Senha",
    "UserPrivacyAgreement": "Política de Privacidade do Usuário"
  },
  "information": {
    "_2602": "Dispositivo offline",
    "_2603": "Falha na transmissão",
    "_2604": "A transmissão foi cortada",
    "_2605": "O espaço de armazenamento está cheio",
    "_2606": "há minutos",
    "_2607": "há horas",
    "_2609": "falhou, por favor ",
    "_2609_a": "clique aqui ",
    "_2609_time": "para lidar com isso a tempo",
    "userType": "Administrador",
    "unreadNoticeFirst": "Ler notificações primeiro",
    "sortByTime": "Ordenar por data",
    "coxRead_1": "Lido",
    "coxRead_0": "Não lido",
    "allCoxRead": "Marcar tudo como lido",
    "load": "Carregando...",
    "noData": "Não há mais dados",
    "viewALLMessages": "Ver TODAS as notificações"
  },
  "input": {
    "select": "Por favor selecione",
    "thisField": "Este campo deve ser preenchido.",
    "titleShooleNub60": "menos de 60 caracteres",
    "titleShooleNub300": "menos de 300 caracteres",
    "Offline": "Fora de linha"
  },
  "schedule": {
    "OnlyManual": "Somente Manual",
    "runStartNow": "Executar Tarefa",
    "runStopNow": "Parar Tarefa",
    "tackExecutionStart": "Tarefa em execução",
    "tackExecutionStop": "Execução de tarefa parada",
    "dehumidification": "Desumidificação",
    "airSupply": "Fornecimento de ar",
    "masterControl": "principal:",
    "powerSupply": "Potência",
    "lockScreen": "Bloqueio",
    "RecordingControl": "Controle de gravação",
    "RecordingControlSystem": "Sistema de captura de conferências",
    "LiquidCrystal": "Tela LCD interativa",
    "projector": "Projetor",
    "othertype": "Outro",
    "childLock": "Bloqueio infantil",
    "energySaving": "Economia de energia",
    "signalSourceSwitching": "Fonte de entrada",
    "other": "Outras funcionalidades:",
    "otherFunction": "Função",
    "send": "Enviar",
    "ON": "LIGADO",
    "OFF": "DESLIGADO",
    "btnAddSchedule": "Restaurar",
    "EditSchedulelist": "Editar Agendador",
    "AddSchedulelist": "Adicionar Agendador",
    "RestoreSchedulelist": "Restaurar",
    "btn": "Cancelar",
    "btnNewList": "Novo Agendador",
    "ListName": "Nome",
    "Cannotquit": "Obrigatório",
    "NOCannotquit": "NÃO",
    "ListValidityPeriod": "Período de validade",
    "ListDescription": "Descrição",
    "currentSchedule": "Lista de Agendadores",
    "historySchedule": "Lista de Histórico",
    "selectTime": "Tempo",
    "selectTimeTable": "Tempo",
    "taskType": "Tipo de tarefa",
    "selectBroadcasting": "Transmissão",
    "selectDeviveControl": "Controle de dispositivo",
    "newSchedule": "Nova tarefa",
    "newChecklist": "Nova lista de verificação",
    "titleStatus": "Status",
    "titleType": "Tipo",
    "titleStartTime": "Hora de Início",
    "titleEndTime": "Hora de Término",
    "titleRepeat": "Repetir",
    "titleName": "Nome",
    "titleAction": "Ação",
    "tableEnabled": "Ativado",
    "tablePaused": "Pausado",
    "tableEdit": "Editar",
    "tableDelete": "Excluir",
    "tableVolumeEdit": "Volume de Transmissão",
    "tableBroadcastTitle": "Título",
    "tableBroadcastContent": "Conteúdo",
    "tableBroadcastList": "Lista",
    "tableBroadcast": "Obrigatório",
    "btnRemoveCompletely": "Remover completamente",
    "btnEnabled": "Tarefa habilitada",
    "btnPaused": "Desabilitar tarefa",
    "btnDelete": "Excluir",
    "repeat0": "SEG",
    "repeat1": "TER",
    "repeat2": "QUA",
    "repeat3": "QUI",
    "repeat4": "SEX",
    "repeat5": "SÁB",
    "repeat6": "DOM",
    "dialogTitleAdd": "Nova tarefa de controle de dispositivos",
    "dialogTitleEdit": "Editar tarefa de controle de dispositivos",
    "newBroadcastingSchedule": "Nova tarefa de transmissão",
    "editBroadcastingSchedule": "Editar tarefa de transmissão",
    "chooseDevice": "Escolher dispositivo",
    "timeSetting": "Configuração de hora",
    "controlBroadcasting": "Opção de transmissão",
    "controlOption": "Opção de controle",
    "scheduleName": "Nome da tarefa:",
    "destination": "Destino",
    "timeTilte": "Hora",
    "repeatTitle": "Repetir",
    "dialogRepeat0": "SEG",
    "dialogRepeat1": "TER",
    "dialogRepeat2": "QUA",
    "dialogRepeat3": "QUI",
    "dialogRepeat4": "SEX",
    "dialogRepeat5": "SÁB",
    "dialogRepeat6": "DOM",
    "dialogOnceType": "Uma vez",
    "dialogRepeatType": "Repetir",
    "Manual": "Manual",
    "ManualContent": "Você pode executar essas tarefas manualmente depois de terminar a configuração.",
    "mainPower": "Energia principal",
    "powerControl": "Controle de energia",
    "tableDisplayInputSwitch": "Alternância de entrada de display",
    "tableAirConditioning": "Ar condicionado",
    "tableProjectionScreen": "Tela de projeção",
    "tableElectronicLock": "Fechadura elétrica",
    "interactiveFlatPanel": "Painel interativo",
    "displayInputSwitch": "Alternância de entrada de display",
    "speakerVolume": "Volume de áudio",
    "MICVolume": "Volume do microfone",
    "ProjectionScreen": "Tela de projeção",
    "ElectronicLock": "Fechadura elétrica",
    "AirConditioning": "Ar condicionado",
    "AirConditioningPower": "Energia",
    "AirConditioningModel": "Modelo",
    "AirConditioningTEMP": "Temperatura",
    "AirConditioningFanSpeed": "Velocidade do ventilador",
    "OPEN": "ABRIR",
    "CLOSE": "FECHAR",
    "UP": "CIMA",
    "DOWN": "BAIXO",
    "PowerOFF": "DESLIGADO",
    "PowerON": "LIGADO",
    "ModelAuto": "Automático",
    "ModelCool": "Frio",
    "ModelHeat": "Calor",
    "ModelAir": "Lado do ar",
    "TEMPLow": "Baixo",
    "TEMPMiddle": "Médio",
    "TEMPHigh": "Alto",
    "btnSave": "Salvar",
    "btnNext": "PRÓXIMO",
    "StartTime": "Hora de início",
    "StopTime": "Hora de término",
    "Mandatory": "Obrigatório",
    "Video": "Vídeo e Áudio",
    "Notification": "Notificação",
    "btnFile": "Selecionar um arquivo de mídia",
    "LastingTime": "Tempo de duração",
    "textTitle": "Título",
    "textContent": "Conteúdo",
    "textTitleLetters": "Menos de 60 caracteres",
    "textContentLetters": "Menos de 320 caracteres",
    "CannotquitYES": "SIM",
    "CannotquitNo": "Não",
    "YES": "Tem certeza de que deseja excluir este agendador?",
    "No": "O agendador excluído será movido para a lista de histórico e poderá ser restaurado",
    "delTitleContent": "Excluir o agendador?",
    "delTitleListContent": "Excluir o agendador fará com que as tarefas associadas sejam limpas, por favor, confirme.",
    "deleListTitle": "Tem certeza de que deseja excluir este agendador?",
    "delTitleListContent1": "Excluir?",
    "deleListTitle1": "Confirmar",
    "delTitle": "TODOS",
    "btnConfirm": "Transmissão",
    "coxAll": "Controle de Dispositivo",
    "coxBroadcasting": "SIM",
    "coxDeviveControl": "NÃO",
    "rdMandatory": "Data de início",
    "noRdMandatory": "Data de término",
    "startDate": "-",
    "endedDate": "Tipo",
    "or": "Escolher hora",
    "broadcastingType": "Escolher data",
    "ChooseTime": "Novo agendador",
    "ChooseDate": "Editar agendador",
    "newScheduleList": "Nome",
    "editScheduleList": "Período de validade",
    "listName": "Descrição",
    "listValidityPeriod": "Cancelar",
    "listDescription": "Confirmar",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "save": "Salvar",
    "addSuccess": "Adicionado com sucesso!",
    "addError": "Falha ao adicionar!",
    "editSuccess": "Editado com sucesso!",
    "editError": "Falha ao editar!",
    "delSuccess": "Excluído com sucesso!",
    "delError": "Falha ao excluir!",
    "restoreSuccess": "Lista de agendamentos restaurada com sucesso",
    "restoreError": "Falha ao recuperar a lista de agendamentos",
    "restoreTitleContent": "Este horário entra em conflito com o horário da lista, por favor selecione novamente",
    "Enabled": "Ativado",
    "Paused": "Pausado",
    "Title": "Título:",
    "Content": "Conteúdo:",
    "errorScheduleNameRequired": "O nome da tarefa deve ser preenchido",
    "errorDeviceRequired": "Por favor, selecione o dispositivo de destino",
    "deleTitle": "Tem certeza de que deseja excluir esta tarefa?",
    "loopList": "Lista de loops",
    "errorPleaseDateRange": "Por favor, selecione um intervalo de datas",
    "addError_2009": "Nome do agendador duplicado",
    "conflicts": "O horário da tarefa entra em conflito com o seguinte:",
    "Pleaseagain": "Por favor, insira novamente",
    "errorScheduleName": "Nome da tarefa",
    "errorListName": "Nome do agendador",
    "today": "Hoje",
    "yesterday": "Ontem",
    "thisWeek": "Esta semana",
    "lastWeek": "Semana passada",
    "lastMonth": "Mês passado",
    "thisMonth": "Este mês",
    "times": "Vezes",
    "TimeConflicts": "Conflitos de horário",
    "editError_2006": "Dispositivo não encontrado",
    "editError_2010": "Nome de tarefa duplicado",
    "editError_2100": "A tarefa expirou, não é possível iniciar.",
    "ListTimeExpired": "O horário do agendador expirou, por favor, selecione novamente",
    "TimeExpired": "Tempo expirado",
    "ControlOption": "Opção de controle ausente",
    "Pleaseleastone": "Por favor, selecione pelo menos uma opção de controle",
    "Enter": "Entrar",
    "TitleFilled": "O título deve ser preenchido",
    "ContentFilled": "O conteúdo deve ser preenchido",
    "PleaseMediaFile": "Por favor, selecione um arquivo de mídia",
    "PleaseSchedule": "Por favor, selecione uma tarefa",
    "delTitleScheduleContent": "A tarefa excluída não pode ser recuperada.",
    "deleTitleSchedule": "Tem certeza de que deseja excluir esta tarefa?",
    "deleteScheduleTitle": "Por favor, selecione a tarefa para excluir",
    "PleaseFillColumn": "Por favor, preencha o nome do agendador",
    "PleaseDate": "Por favor, selecione a data",
    "Previous": "Anterior",
    "RemoteControl": "Controle remoto",
    "taskhasexpired": "Esta tarefa expirou, por favor, entre em contato com o criador para atualizar o horário.",
    "execute": "Executar",
    "broadcastingList": "Lista de transmissão",
    "volumeSuccess": "Volume configurado com sucesso",
    "volumeFailed": "Falha ao configurar o volume"
  },
  "live": {
    "StreamingRoom": "Sala de streaming",
    "btnAddNewRoom": "Adicionar nova sala",
    "Steaming": "Streaming",
    "Creater": "host:",
    "Address": "Endereço RTMP:",
    "StreamingURL": "URL da transmissão ao vivo:",
    "DestinationNMP": "Selecionar destino NMP:",
    "stop": "PARAR",
    "stat": "INICIAR",
    "btnCope": "Clique para COPIAR",
    "QRcode": "Código QR",
    "Refresh": "Atualizar",
    "AddNewRoomTitle": "Adicionar nova sala de streaming",
    "editNewRoomTitle": "Editar sala de streaming",
    "roomName": "Nome da sala:",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "save": "Salvar",
    "delTitleContent": "Tem certeza de que deseja excluir este agendamento?",
    "delTitle": "Excluir?",
    "delCancelButton": "Cancelar",
    "delConfirmButton": "Confirmar",
    "addSuccess": "Adicionado com sucesso!",
    "addError": "Falha ao adicionar!",
    "editSuccess": "Editado com sucesso!",
    "editError": "Falha ao editar!",
    "delSuccess": "Excluído com sucesso!",
    "delError": "Falha ao excluir!",
    "Stopstreaming": "Parar transmissão",
    "Startstreaming": "Iniciar transmissão",
    "error2504": "Não foi possível obter o endereço de transmissão ao vivo do servidor de mídia",
    "error2505": "Nome da sala de transmissão duplicado",
    "error2506": "O dispositivo foi ocupado por outro sinal de transmissão",
    "error1900": "O parâmetro acessado está vazio",
    "error2503": "Não foi possível obter informações do servidor de mídia",
    "error2507": "Endereço de transmissão ao vivo duplicado",
    "copySuccess": "O conteúdo foi copiado para a área de transferência.",
    "copyError": "O navegador não suporta cópia automática",
    "flashControl": "O Flash não está instalado ou ativado. Por favor, tente novamente após instalar ou ativar o Flash.",
    "liveStreaming": "Nenhuma fonte de transmissão ao vivo encontrada.",
    "btnflash": "Instalar/Ativar",
    "serverAddress": "Endereço do servidor",
    "addressKey": "Chave:",
    "watchingAddress": "Endereço de visualização",
    "audioOnly": "Somente áudio",
    "enterTheKey": "A chave deve ser preenchida."
  },
  "guidepages": {
    "next": "Próximo dispositivo de controle",
    "next1": "Próximo tentar controlar",
    "next2": "Próximo transmissão",
    "next3": "Próximo iniciar transmissão",
    "next4": "Próximo parar transmissão",
    "next5": "Próximo transmissão de texto",
    "next6": "Próximo configurar tarefa",
    "next7": "Próximo adicionar nova tarefa",
    "next8": "Próximo lista de histórico",
    "next9": "Próximo armazenamento em nuvem",
    "next10": "Próximo transmissão ao vivo",
    "next11": "Próximo configurar transmissão ao vivo",
    "exit": "Sair",
    "guideContent": "Conteúdo do guia",
    "btnHomepage": "Página inicial",
    "btnDevices": "Dispositivos",
    "btnBroadcast": "Transmissão",
    "btnSchedule": "Agendamento",
    "btnResources": "Recursos",
    "btnStreaming": "Ao vivo",
    "btnPrevious": "Anterior"
  },
  "privacy": {
    "PrivacyPolicy": "Q-NEX Privacy Policy",
    "Byusing": "By using the Q-NEX service, you are trusting us to process your information. We understand that this responsibility is important, so we have been committed to protecting your information and giving you control.",
    "whatinformation": "This Privacy Policy is designed to help you understand what information we collect, why it is collected, and how you manage your information.",
    "EffectiveDate": "Effective Date: January 1, 2020",
    "title1": "Q-NEX Respects Your Privacy",
    "title1Respects1": "Returnstar Interactive Technology Group Co.,Ltd. and its sub-brand (collectively “Q-NEX”, “we” or “us”) respect your privacy and understand that the processing and security of your personal data is important to you. Please review the full Privacy Policy below for more complete details on how we collect, use, share, and protect your personal data, as well as the choices you have regarding our use and sharing of your personal data, along with other important considerations.",
    "title1Respects2": "This Privacy Policy explains Q-NEX’s practices regarding the processing (such as the collection, use, storage, copy or disclosure) of your personal data received: (i) through our website https://www.qnextech.com (“Website”), email, and other written or in person communications; (ii) in the context of all our commercial relations with customers, end-users, dealers, distributors, suppliers, contractors, agents or representatives; and (iii) in the normal course of any other potential business relationship. We commit to comply with our obligations under all applicable Privacy and Data Protection Laws, as described below, including but not limited to the Provisions on Protection of Personal Information of Telecommunications and Internet Users, and to respect your rights whenever we are processing your personal data.",
    "title2": "Privacy and Data Protection",
    "title2Respects1": "“Personal Data” means any information that identifies, or can be used to identify, an individual.",
    "title2Respects2": "“Privacy and Data Protection Laws” means any and/or all laws, rules, directives and regulations, on any local, provincial, state, federal or national level within and outside the People's Republic of China, pertaining to data privacy, data security and/or the protection of Personal Data. Among them, laws and regulations outside China include but not limited to: (a) the General Data Protection Regulation (GDPR) and each European Union Member States’ national implementation thereof; (b) the Australian Privacy Act 1988 (Cth) and the Australian Privacy Amendment (Enhancing Privacy Protection Act) (2012); (c) the Belgian Privacy Law of 8 December 1992; (d) the Canadian Personal Information Protection and Electronic Documents Act, SC 2000, c 5 (PIPEDA); (e) the Personal Data Protection Act 2012 of Singapore (PDPA); (f) additional privacy and data protection laws applicable to a data subject’s location; and (g) any successor legislation or regulations applicable thereto.",
    "title3": "When Do We Collect Your Personal Data?",
    "title3Respects1": "Q-NEX may collect your personal data when you communicate with us by phone, e-mail, the Website or otherwise, in the context of:",
    "title3a": "Browsing our Website or visiting our social media sites;",
    "title3b": "Corresponding with Q-NEX;",
    "title3c": "Visiting one of our offices, events or facilities;",
    "title3d": "Registering for and/or participating in our conferences, events, training or other activities;",
    "title3e": "Requesting information, support, service, materials, assistance or other inquiries;",
    "title3f": "Subscribing to a newsletter or other mailing list;",
    "title3g": "Exchanging business cards;",
    "title3h": "Completing Website contact forms, questionnaires, surveys, or contest entry forms or otherwise participating in these activities;",
    "title3i": "Engaging in commercial relationships or other collaboration;",
    "title3j": "Ordering or registering Q-NEX products;",
    "title3k": "Creating or registering an account;",
    "title3l": "Uploading or downloading files;",
    "title3m": "Verification of your identity as a data subject; or",
    "title3n": "Using Q-NEX products that are connected to the Internet, including mobile apps, cloudware, and certain hardware devices.",
    "title4": "Which Types of Personal Data are Processed by Us?",
    "title4Respects1": "Q-NEX may process the following personal data:",
    "title4a": "Name, surname, title, company, email address, phone number (mobile and landline), address, signature and other contact information;",
    "title4b": "IP addresses;",
    "title4c": "Location data;",
    "title4d": "Cookie ID;",
    "title4e": "Language;",
    "title4f": "Personal preferences regarding communications and/or products and services;",
    "title4g": "Financial details (e.g. payment information, bank account number, and credit information);",
    "title4h": "Personal data regarding projects using Q-NEX products and services;",
    "title4i": "Personal data provided in your submissions, responses and feedback;",
    "title4j": "Personal data regarding your interactions with Q-NEX, including your use of the Website and of Q-NEX’s products or services;",
    "title4k": "Social media data, images, photos, and camera footage; and",
    "title4l": "Any other personal data provided by you or by your authorized Q-NEX dealer or service provider.",
    "title4Respects2": "For the avoidance of doubt, Q-NEX does not collect any sensitive personal data, such as racial or ethnic origin; political opinions; religious or philosophical beliefs; genetic characteristics; health information; sexual preferences; information about children; criminal convictions; or biometric data, and we explicitly ask that you not provide us with such data in your responses or feedback to us.",
    "title5": "How Do We Use Your Personal Data?",
    "title5Respects1": "In order to better manage our own business needs and to better communicate with you, we may collect, analyze, use and otherwise process your personal data for the following purposes:",
    "title5a": "To respond to your inquiries, questions and other requests;",
    "title5b": "To optimize and manage the quality and content of our Website, including the ability to personalize and secure your Website experience;",
    "title5c": "To create and maintain your website, customer and product accounts and registrations;",
    "title5d": "To provide you with marketing, advertising, promotions, programs, offers and other opportunities; including newsletters, information on products and services, subscriptions, training, updates and direct marketing, which may be targeted, based on your communication preferences;",
    "title5e": "To conduct customer satisfaction studies, surveys and other market research;",
    "title5f": "To manage our events and activities, and invite you to events;",
    "title5g": "To register visitors to our offices, facilities and events;",
    "title5h": "To create promotional materials, including videos, photos, articles, case studies, newsletters and other materials regarding projects or events;",
    "title5i": "To provide products, services, training, technical support, customer service and other assistance;",
    "title5j": "To manage and perform our agreements and obligations;",
    "title5k": "To respond to and follow up on business leads, opportunities, and contacts;",
    "title5l": "To process payments, orders, invoicing, returns, collection and other requests;",
    "title5m": "To provide pricing, quotations and custom configurations of our products and services;",
    "title5n": "To grant you access to our software, training, technical information and other proprietary content;",
    "title5o": "To evaluate, troubleshoot, analyze and improve the use, functionality, features, and performance of our products, services, training, technical support and customer service;",
    "title5p": "To gather, analyze and maintain configuration and backup data regarding our products and services;",
    "title5q": "To facilitate planning, analytics, forecasting and reporting regarding our products and services;",
    "title5r": "To use for our internal business operations and processes, including business and financial recordkeeping, data management and business continuity; and",
    "title5s": "To meet our legal and regulatory obligations.",
    "title6": "Which Legal Basis Applies To Our Processing Of Your Personal Data?",
    "title6Respects1": "The following legal grounds might apply to the processing of your personal data for the purposes mentioned above:",
    "title6a": "Processing is necessary for the performance of your agreement with us or in order to take all pre-contractual steps;",
    "title6b": "Processing takes place based upon our legitimate interest (comply with obligations, maintain business records, fraud prevention, network and information security, etc.). When carrying out this type of processing, we strive to strike a balance between this legitimate interest and respect for your privacy;",
    "title6c": "You have given your consent to the processing (e.g. in case of direct marketing, for the processing of analytic cookies and for data transfers to third parties);",
    "title6d": "In order to comply with our legal obligations (such as tax administration and record retention); or",
    "title6e": "In very exceptional circumstances to protect your vital interest or that of someone else.",
    "titel7": "To Whom Do We Disclose Your Personal Data?",
    "title7Respects1": "Q-NEX may disclose your personal data to yourself, to Q-NEX’s affiliates or to third parties, such as payment providers, software providers, cloud partners, transport partners, financial institutions, insurance companies, legal services, or certain other service providers or partners that Q-NEX has a strategic relationship with, in order to fulfill our relationship with you in the most effective way.",
    "title7Respects2": "Q-NEX will not disclose to third parties any personal data you submit for purposes other than those described in this Privacy Policy. If, in the future, we intend to disclose your personal data to third parties for any purpose other than those described in this Privacy Policy we shall inform you thereof in advance and ask your consent if required.",
    "title7Respects3": "Notwithstanding the foregoing, Q-NEX will disclose your personal data to a third party (such as competent authorities) if required to do so by law, during a legal proceeding, or if, in good faith, Q-NEX believes that such action is necessary to comply with certain laws, rules or regulations.",
    "titel8": "Which Guarantees Do We Provide in Case of International Data Transfers?",
    "title8Respects1": "Q-NEX is a global company and we may transfer your information to Q-NEX affiliates, representatives or third party contractors who represent us worldwide. Each affiliate, representative, or third party contractor works closely with Q-NEX, and any transfer of personal data between these associated entities will comply with applicable Privacy and Data Protection Laws.",
    "title8Respects2": "If any transfer of the personal data of residents of the European Economic Area (EEA) is made to a person or entity located in a country outside of the EEA, that is not recognized as providing an adequate level of protection, we will provide for increased information security and appropriate contractual provisions to strengthen data protection. To ensure that any such transfers of the personal data of EEA residents are compliant with the applicable Privacy and Data Protection Laws, we will either (i) conclude a data transfer agreement, based upon the EU model agreements, (ii) adopt binding corporate rules, (iii) rely on legally determined exceptions (such as requesting your explicit consent) or (iv) adopt other mechanisms which have been deemed to provide for the adequate protection of your personal data.",
    "titel9": "How Do We Secure Your Personal Data?",
    "title9Respects1": "We use a variety of security technologies and precautions, such as the Secure Socket Layer (SSL) protocol (encryption), to help protect your personal data from loss, theft, misuse and unauthorized access, in accordance with industry standards. To protect any personal data stored on Q-NEX servers or cloud-based storage, we regularly monitor our systems for vulnerabilities or attacks, and implement up to date information security measures.",
    "title9Respects2": "Access to personal data that is processed by Q-NEX is limited only to those of its employees, contractors and affiliated organizations that need to know that information in order to process it on Q-NEX’s behalf, in accordance with this Privacy Policy, and that have agreed not to disclose it to others.",
    "titel10": "How Long Do We Retain Your Personal Data?",
    "title10Respects1": "Unless a longer retention period is required by law, Q-NEX will retain your personal data for as long as needed to fulfil the relevant purposes described in this Privacy Policy.",
    "titel11": "Use of Cookies",
    "title11Respects1": "Q-NEX uses cookies on our Website, both to enable the site to work properly, and to enhance your experience while visiting our Website. Cookie file(s), which are stored on the hard drive of your computer, enable us to obtain information about your usage of our Website, and to measure and improve the performance of our Website. Cookies enable you to store your preferences, in order to enable our Website to recognize these preferences when you browse our Website.",
    "title11Respects2": "You may refuse to accept cookies by activating the setting on your browser which allows you to refuse cookies. However, if you select this setting you may not be able to access certain sections or features of our Website. Unless you have adjusted your browser setting so that it will refuse cookies, our system will issue cookies to your computer whenever you log on to our Website.",
    "title11Respects3": "When you visit our Website for the first time you will be provided with a link to this cookie policy and will have the opportunity to change your browser settings to refuse cookies. By continuing to browse our website without changing your settings, you agree to our use of cookies as explained in this policy.",
    "title11Respects4GoogleAnalytics": "Google Analytics.",
    "title11Respects4": "We use industry standard web analytics to track visits to our sites, namely those provided by Google Analytics. The information generated by the cookies about your use of our Website (including your IP address) will be transmitted to and stored by Google Analytics on their servers and is handled in accordance with Google’s Privacy Policy which can be accessed at the following link: https://policies.google.com/privacy.",
    "titel12": "Third Party Links on our Website",
    "title12Respects1": "The Website contains links to other websites. Q-NEX is not responsible for the privacy policy of other websites, or the manner in which they store, use or distribute information. Q-NEX encourages you to review the privacy policy of any website you may visit.",
    "titel13": "Children’s Information",
    "title13Respects1": "Q-NEX’s Website is not intended for use by children, and its products and services are not sold to children. In accordance with the Children’s Online Privacy Protection Act, we do not collect or maintain information from persons we know are under 18, and no part of the Website is designed to attract anyone under age 18.",
    "titel14": "What Are Your Rights and How Can You Exercise Them?",
    "title14Respects1": "If you are a natural person, you have the right at all times to be informed about the personal data we process about you, and to the extent authorized under the applicable Privacy and Data Protection Laws, to request access, modification, limitation of processing, transfer or deletion of personal data, or to object to the processing of your personal data, subject to the exceptions within the applicable Privacy and Data Protection Laws.",
    "title14Respects2": "If processing is based solely on your consent, you also have the right to revoke your consent at any time, without prejudice to the lawfulness of processing prior to revocation.",
    "title14Respects3": "Through the contact options listed below, you can exercise the above rights regarding the processing of your personal data by Q-NEX, except in cases where this would require a disproportionate effort on the part of Q-NEX.",
    "title14Respects4": "Please feel free to use the contact information listed below if you have any additional concerns regarding your personal data or your exercise of the above rights, and we will do our best to assist you.",
    "title14Respects5": "If you contact us to exercise one of your rights under the applicable Privacy and Data Protection Laws, we will reply within one (1) month. In certain exceptional circumstances, we may take up to three (3) months to fully respond to you, but in such case we shall inform you why we require additional time to respond in our initial reply.",
    "title14Respects6": "If we are unable to resolve an inquiry or request, where applicable, you may have the right to lodge a complaint with the local data protection authority.",
    "titel15": "Stay Informed of Changes in Our Privacy Policy",
    "title15Respects1": "In a world in which technology and legislation is constantly changing, this Privacy Policy may also change. We invite you to always consult the latest version of this policy, posted at https://www.qnextech.com/legal, and we will inform you of any changes via our Website or other common communication channels.",
    "titel16": "Contact Q-NEX",
    "title16Respects1": "If you have questions and/or comments about this Privacy Policy or the manner in which Q-NEX collects, uses and/or processes your personal data, please contact us:",
    "title16Respects2": "Via e-mail: info@qnextech.com"
    }
}



// WEBPACK FOOTER //
// ./src/lang/pt.js